export const SecurityContext = {
	Host: "web_Host",
	Menu: "portal_Menu",
	RestrictByAssociation: "restrictByAssociation",
	Contact: "portal_Contact",
	Location: "portal_Menu",
	AdminGroupUser: "adminGroupUser",
	ManageUserGroup: "manage_UserGroup"
} as const;

export const SecurityContextPermission = {
	Menu: {
		Customers: "Web_Customers_Dashboard"
	},
	Customer: {
		Read: "Web_Customers_Read"
	},
	Location: {
		Read: "Web_Locations"
	}
} as const;
